import './new-role.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateRole } from "@core/query/role.query";
import { RoleFormRule, RoleFormSchema } from "@core/form/form.rule";
import { roleFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormRole from "../form-role/form-role";

export function Role() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateRole } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Role is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addRole, isLoading: isCreating } =
    useQyCreateRole(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<RoleFormSchema>({
    defaultValues: roleFormDefault,
    resolver: zodResolver(RoleFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: RoleFormSchema) => {
    const formData = mapCreateRole(form);
    addRole(formData);
  };
  const handleValidateError = (err: FieldErrors<RoleFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="Role" className="role">
      <HeaderContent
        title="New Role"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormRole />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default Role;